import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if (process.env.VUE_APP_ENV != 'local') {
    Raven.config('https://71534f4875064821bf39c1094aae65f4@sentry.io/161897', {
        environment: process.env.VUE_APP_ENV,
        release: process.env.COMMIT_REF,
    })
        .addPlugin(RavenVue, Vue)
        .install();
}

window.Raven = Raven;
